<script lang="ts">
    import {addToMarketPlace, cancelSell, getEgg, getLootboxes} from 'src/components/cabinet/#services/inventory'
    import background from 'src/components/main/marketplace/components/nft-cards/background.svg'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte'
    import egg from 'src/components/cabinet/inventory/egg.svg'
    import {Link} from 'svelte-routing'
    import {showAlert} from 'src/components/#common/alert/store'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
    import Hatching from 'src/components/cabinet/inventory/components/egg/Hatching.svelte'
    import {roundNumber} from 'src/components/#common/helpers/helpers'
    import Timer from 'src/components/cabinet/inventory/components/Timer.svelte'
    import {confirmAction, isConfirmedAction} from 'src/components/main/#services/marketplace'
    import {delay} from 'src/global/delay'

    export let category

    let code
    let currentPage = 0
    let perPage = 20
    let minAmount = 1
    let amount
    let sellNftModal = false
    let openMintModal = false
    let loading = false
    let selectedProductId
    let hatchingStart = new Date(Date.UTC(2023, 6, 19, 0, 0))
    let hatchingStartInMls = hatchingStart.getTime()
    let now = new Date().getTime()

    getLootboxes.reset()

    $: currentPage, filter()

    function filter() {
        getLootboxes.send({ data: {
            page: currentPage + 1,
            perPage
        }})
        // window.scrollTo(0, inventoryContainer?.offsetTop)
    }

    async function cancelSellNftHandler(e, productId) {
        e.preventDefault()

        try {
            loading = true

            await cancelSell.request({ data: { productId } })

            showAlert.set({
                status: 'success',
                text: 'NFT sale successfully canceled'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            filter()
        }
    }

    async function sellNftHandler(e) {
        e.preventDefault()

        try {
            loading = true

            await addToMarketPlace.request({ data: {
                productId: selectedProductId,
                price: amount,
                currency: 'USDT',
                productType: 'lootbox'
            } })

            amount = ''

            showAlert.set({
                status: 'success',
                text: 'You have successfully published your NFT in the marketplace'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            sellNftModal = false
            loading = false
            filter()
        }
    }

    function handleOpened() {
        filter()
    }

    async function confirmActionHandler() {
        try {
            loading = true
            await confirmAction.request({data: {code}})
        } catch (err) {
            console.error(err)
        } finally {
            await delay(300)
            loading = false
            isConfirmedAction.reset()
            isConfirmedAction.send()
        }
    }
</script>

<div class="row inventory-cards">
    {#if !$getLootboxes.hasValue && $getLootboxes.loading}
        <div class="color-white text-center">Loading...</div>
    {:else if !$getLootboxes.hasValue && $getLootboxes.error }
        <div class="color-white text-center">Something went wrong</div>
    {:else if $getLootboxes.hasValue && $getLootboxes.value?.lootboxesList}
        {#each $getLootboxes.value.lootboxesList as {productId, status}}
            {#if status === 'approving' || status === 'transfering'}
                <div class="nft-card card-0 disabled" style="--Background:url({background});">
                    <div class="rarity">
                        <div class="rarity-value notranslate">NFT Egg</div>
                        <div class="level notranslate">
                            <span>
                                {#if status === 'approving'}
                                    Minting...
                                {:else if status === 'transfering'}
                                    Transferring...
                                {/if}
                            </span>
                        </div>
                        <div class="image">
                            <img src="{egg}" alt="nft egg">
                        </div>
                    </div>
                </div>
            {:else if status === 'approved' || status === 'inMarket'}
                <Link to="inventory/egg/{productId}" class="nft-card card-0" style="--Background:url({background});">
                    <div class="rarity">
                        <div class="rarity-value notranslate">NFT Egg</div>
                        <div class="level notranslate"><span>#{productId.split(":")[1]}</span></div>
                        <div class="image">
                            {#if status === 'inMarket'}
                                <div class="for-sale">On sale</div>
                            {/if}
                            <img src="/images/eggs/egg-{productId.slice(-1)}.png" alt="nft egg">
                        </div>
                    </div>
                    <div class="buttons-group">
                        {#if status === 'approved'}
                            <button class="btn btn-primary" disabled={loading} on:click={(e) => {
                                e.preventDefault()
                                selectedProductId = productId
                                isConfirmedAction.reset()
                                isConfirmedAction.send()
                                sellNftModal = true
                            }}>
                                <span>Sell egg</span>
                            </button>
                            {#if hatchingStartInMls > now}
                                <button class="btn btn-primary d-block" on:click={(e) => {e.preventDefault()}}>
                                    <span>Hatching starts in<Timer targetDate={hatchingStart}/></span>
                                </button>
                            {:else}
                                <button class="btn btn-primary" on:click={(e) => {e.preventDefault(); selectedProductId = productId; openMintModal = true}}>
                                    <span>Open egg</span>
                                </button>
                            {/if}
                        {:else if status === 'inMarket'}
                            <button class="btn btn-primary" on:click={(e) => cancelSellNftHandler(e, productId)} disabled={loading}>
                                <span>Cancel sale</span>
                            </button>
                        {/if}
                    </div>
                </Link>
            {/if}
        {:else}
            <div class="no-data">No data yet</div>
        {/each}
    {/if}
</div>
<div class="text-center">
    <Pagination
        bind:currentPage={currentPage}
        totalCount={$getLootboxes?.value?.totalCount}
        {perPage}
        disabled={!$getLootboxes.hasValue && $getLootboxes.loading}/>
</div>
<Modal bind:visible={sellNftModal}>
    <svelte:fragment slot="content">
        <div class="modal-custom__title">Sell egg</div>
        {#if !$isConfirmedAction.hasValue && $isConfirmedAction.loading}
            <div class="modal-custom__text text-center">Loading...</div>
        {:else if !$isConfirmedAction.hasValue && $isConfirmedAction.error}
            <div class="modal-custom__text text-center">Something went wrong. Try refreshing the page.</div>
        {:else if $isConfirmedAction.hasValue}
            {#if !$isConfirmedAction.value}
                <div class="modal-custom__text">
                    <p>We have sent an email confirming the marketplace actions</p>
                    <div class="text-center">
                        <div class="form-group mb-3">
                            <input type="text" class="form-control confirm-action-field" bind:value={code} placeholder="Enter code">
                            <div class="invalid-feedback mt-2" class:d-block={$confirmAction.error}>{$confirmAction.error}</div>
                        </div>
                        <button class="btn btn-primary" on:click={confirmActionHandler} class:loading={loading} class:disabled={!code}>
                            <span>Confirm</span>
                        </button>
                    </div>
                </div>
            {:else}
                <div class="modal-custom__text">
                    <div class="nft-mini-img">
                        <img src="/images/eggs/egg-{selectedProductId.slice(-1)}.png" class="modal-nft" alt="nft">
                    </div>
                    <div class="commission-text">Fees: <span>4%</span></div>
                    <div class="commission-text mb-3">You will get: <span class="color-green">
                        {amount >= 1 ? roundNumber(amount * 0.96) : '-'} USDT</span>
                    </div>
                    <div class="form-group">
                        <div class="input-group justify-content-center">
                            <input type="number" class="form-control amount" bind:value={amount} placeholder="Enter amount">
                            <span class="input-group-text empty-input-group-text">USDT</span>
                        </div>
                    </div>
                </div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { sellNftModal = false }}>Close</button>
                    <button class="btn btn-primary" class:loading={loading} on:click={(e) => sellNftHandler(e)}
                        disabled={!amount || amount < minAmount || loading}><span>Submit</span></button>
                </div>
            {/if}
        {/if}
    </svelte:fragment>
</Modal>
<Modal bind:visible={openMintModal}>
    <svelte:fragment slot="content">
        <div class="modal-custom__title">You got NFT</div>
        <div class="modal-custom__text">
            <Hatching productId={selectedProductId} on:opened={handleOpened}/>
        </div>
    </svelte:fragment>
</Modal>

<style>
    .no-data {
        color: #b4c1cf;
        font-size: 18px;
        text-align: center;
    }

    .for-sale {
        position: absolute;
        z-index: 2;
        font-size: 12px;
        line-height: 1;
        color: white;
        background: #FF5D1C;
        padding: 6px 7px;
        border-radius: 5px;
        right: 5px;
        top: 5px;
    }

    .elements img {
        width: 35px;
        height: 35px;
    }

    .elements img:not(:first-child) {
        margin-left: -10px;
    }

    .rarity {
        margin: 5px;
        position: relative;
        overflow: hidden;
    }

    .rarity:before {
        content: "";
        border-radius: 8px;
        width: 100%;
        height: calc(100% - 30px);
        position: absolute;
        background: #61758a;
        left: 0;
        top: 0;
    }

    .rarity-value {
        padding: 10px 15px;
        position: relative;
        color: white;
        font-size: 13px;
        font-weight: 500;
        line-height: 1;
        height: 33px;
    }

    .inventory-cards {
        margin: 50px 0 26px;
    }

    .buttons-group {
        position: absolute;
        bottom: -100%;
        width: 100%;
        background: #24214b;
        border-radius: 0 0 6px 6px;
        padding-top: 5px;
        border-top: 2px solid #494591;
        z-index: 2;
        transition: .25s;
    }

    .buttons-group .btn {
        padding: 8px 12px !important;
        font-size: 14px;
    }

    .inventory-cards :global(.nft-card:hover .buttons-group) {
        bottom: 0;
    }

    .inventory-cards :global(.nft-card) {
        width: 230px;
        margin: 0 30px 30px 0;
        border-radius: 10px;
        background: #26244D;
        border: 2px solid #494591;
        display: block;
        text-decoration: none;
        position: relative;
        padding: 0;
        transition: .25s;
        overflow: hidden;
        cursor: pointer;
    }

    .inventory-cards :global(.nft-card:hover) {
        transform: translateY(-4px);
        box-shadow: 0 8px 10px rgba(160, 174, 192, 0.2);
    }

    .image {
        background: linear-gradient(180deg, #3E2929 -72.66%, #0B0E21 132.58%);
        height: 205px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .level {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 15px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: 1;
        padding: 9px 15px 0 0;
        text-align: right;
        width: 50%;
        height: 33px;
    }

    .level:before {
        content: "";
        width: 100%;
        height: 50px;
        background: #26244D;
        left: 0;
        right: 0;
        top: 0;
        position: absolute;
    }

    .level:after {
        content: "";
        width: 50px;
        height: 70px;
        background: #26244D;
        left: -12px;
        right: 0;
        top: -20px;
        position: absolute;
        transform: rotate(-20deg);
    }

    .level span {
        color: white;
        position: relative;
        z-index: 2;
    }

    .image img {
        max-width: 100%;
        max-height: 100%;
        padding: 25px;
        z-index: 2;
        position: relative;
    }

    .inventory-cards :global(.nft-card .btn) {
        margin: 1px 6px 6px;
        width: calc(100% - 12px);
    }

    .catalog :global(.pagination) {
        justify-content: center;
    }

    .rarity-id-0:before {
        background: linear-gradient(to bottom, #66DC96 , #0B0E21);
    }

    .elements img:nth-child(1) {
        position: relative;
        z-index: 5;
    }

    .elements img:nth-child(2) {
        position: relative;
        z-index: 4;
    }

    .elements img:nth-child(3) {
        position: relative;
        z-index: 3;
    }

    .elements img:nth-child(4) {
        position: relative;
        z-index: 2;
    }

    .elements img:nth-child(5) {
        position: relative;
        z-index: 1;
    }

    .elements img {
        width: 35px;
        height: 35px;
    }

    .elements img:not(:first-child) {
        margin-left: -10px;
    }

    .disabled {
        opacity: 0.7;
        cursor: default;
    }

    .disabled:hover {
        transform: none;
        box-shadow: none;
    }

    .form-control.amount {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
        padding: 10px 15px;
        border-right: 0;
        max-width: 200px;
        border-radius: 8px 0 0 8px;
    }

    .form-control.amount:focus {
        box-shadow: none;
    }

    .form-control.amount:focus,
    .form-control.amount:focus + span {
        border-color: #FF5D1C;
    }

    .commission-text {
        width: 290px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto 8px;
        font-size: 14px;
    }

    .color-green {
        font-weight: 500;
        color: #27AE60;
    }

    .commission-text {
        width: 290px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto 8px;
        font-size: 14px;
    }

    .empty-input-group-text {
        background: none;
        border-left: 0;
        min-width: initial;
        padding: 0 30px;
        font-size: 20px;
        color: #61758A;
        transition: .25s;
    }

    .nft-mini-img {
        width: 180px;
        height: 180px;
        margin: 0 auto 20px;
        display: block;
        background: #41485e;
        border-radius: 5px;
        padding: 10px;
    }

    .nft-mini-img img {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }

    .form-control.confirm-action-field {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
        padding: 10px 15px;
        margin: 0 auto;
        text-align: center;
        max-width: 200px;
        border-radius: 8px;
    }

    .form-control.confirm-action-field:focus {
        box-shadow: none;
    }

    .form-control.confirm-action-field:focus {
        border-color: #FF5D1C;
    }

    @media(max-width: 767px) {
        .inventory-cards {
            margin-top: 0;
            padding-top: 15px;
            margin-bottom: 5px;
        }

        .inventory-cards :global(.nft-card) {
            width: 100%;
            max-width: 400px;
            margin: 0 auto 20px;
        }

        .inventory-cards :global(.nft-card:hover) {
            transform: none;
            box-shadow: none;
        }

        .image {
            height: calc(100vw - 42px);
            max-height: 388px;
        }

        .image img {
            padding: 40px;
        }

        .nft-box-img img {
            margin: 25px 0 0 -55px;
        }

        .buttons-group {
            position: relative;
            bottom: auto;
            padding-top: 0;
        }

        .commission-text {
            width: 100%;
        }

        .form-control.amount {
            max-width: initial;
        }
    }
</style>
